let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("fliVL"), load("dWA5j")]).then(() => parcelRequire('9zKIx'));